module.exports = __webpack_public_path__ + "img/gift2.a273c62e.png";